import { createFileRoute, Outlet } from "@tanstack/react-router";
import History from "./~quiz/history";

export const Route = createFileRoute("/dashboard/quiz")({
  loader: async ({ context }) => {
    const user = await context.auth.getUser();
    const id = user!.uid;
    return { id };
  },
  component: Quiz,
});

function Quiz() {
  const { id } = Route.useLoaderData();
  return (
    <div className="flex w-full">
      <div className="w-72">
        <History userID={id} />
      </div>
      <Outlet />
    </div>
  );
}
